import { render, staticRenderFns } from "./DomesticComponent.vue?vue&type=template&id=93218638&"
import script from "./DomesticComponent.vue?vue&type=script&lang=js&"
export * from "./DomesticComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports